export default {
      id: "menu__proHub2-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__proHub2",
      toString: function () {
        return this.url;
      }
    }